import { render, staticRenderFns } from "./VFatherProAnamCAxAFSM.vue?vue&type=template&id=334316d5"
import script from "./VFatherProAnamCAxAFSM.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxAFSM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports